import React, {Component} from 'react';
import '../App.css';
import '../css/all.css';


import { Redirect  } from "react-router-dom";
import UpperMenu from '../components/upper_menu/upper_menu.component'
import compose from '../utils/compose'
import withNofeshService  from '../hoc/withNofeshService.hoc';
import Spinner from 'react-bootstrap/Spinner'
import TitleListHotels from '../components/title_list_hotels/titleListHotels.component'
import EmployeeOrderList from '../components/orders_list/employee_order_list.component'


class OrdersListPage extends Component {

  state = {
    redirect: null,
    loading:true,
    modalDisplay:false,
    modalOrderDisplay:false,
    makeOrderData:{},
    makeOrderDataResult : {},
    ordersTitle: '',
    employeeOrdersList: []
  }

  componentDidMount = () => {
          

    const { personData }  = this.props;
    const { nofeshService } = this.props;


    nofeshService.getOrdersList().then( res  => {    
        console.log('OrdersListPage componentDidMount getOrdersList res.data: ', res.data);
        let  resultObj = res.data;
        if (resultObj.status == 1) {
          this.setState( 
            {
              employeeOrdersList: resultObj.employeeOrdersList,
              ordersTitle: resultObj.message,
              loading:false
            });  
        }        
    }); 
  }




  render() {         


    return (      
        <div>                                   
            <div className="hp_banner">
                <UpperMenu   
                    personData={this.props.personData}
                    onLoggedOutRefresh={this.props.onLoggedOutRefresh} />
            </div>
    
            <div className="hp_container">                                          
                {(this.state.loading) ?
                  <React.Fragment>
                      <div className="cntered-flex directionRtl">
                        טוען נתונים ...
                        <Spinner
                            as="span"
                            animation="border"

                            role="status"
                            aria-hidden="true"                                        
                        />      
                      </div>
                    </React.Fragment>
                : null}

                {(!this.state.loading) ?
                  <div className="hp_section_container">
                      <EmployeeOrderList  
                          ordersTitle={this.state.ordersTitle} 
                          employeeOrdersList={this.state.employeeOrdersList}  
                          DisplayForOrder={this.DisplayForOrder}

                      />
                  </div>   
                : null}
                                
            </div>

            <div className="hp_footer">
            </div>
        </div>
    )
  }
}



export default compose(
    withNofeshService(),    
  )(OrdersListPage);



